export const LOAD_VENUE_LIST = 'LOAD_VENUE_LIST';
export const SWITCH_LOADER = 'SWITCH_LOADER';
export const SHOW_SELECTED = "SHOW_SELECTED";
export const CURRENT_LOCATION ="CURRENT_LOCATION";
export const LAT_LONG = "LAT_LONG";
export const DETAIL_PAGE = "DETAIL_PAGE";
export const FETCH_SPORTS = "FETCH_SPORTS";
export const SELECTED_SPORTS = "SELECTED_SPORTS";
export const FILTER_CATEGORY = "FILTER_CATEGORY";
export const FILTER_SAVED_SPORTS =  "FILTER_SAVED_SPORTS";
export const FILTER_SAVED_CATEGORY =  "FILTER_SAVED_CATEGORY";
export const LIST_PAGE_NO = "LIST_PAGE_NO";
export const SHIMMER_START = "SHIMMER_START";
export const VIEWPORT = "VIEWPORT";
export const FETCH_LOCATION = "FETCH_LOCATION";
export const LOCATION_DENIED = "LOCATION_DENIED";
export const CHECKBOX_COUNT = "CHECKBOX_COUNT";
export const GET_ALL_OFFERS = "GET_ALL_OFFERS";
export const OFFER_DETAIL_PAGE = "OFFER_DETAIL_PAGE";
export const HAMBURGER_MENU = "HAMBURGER_MENU";
export const LOAD_EVENT_LIST = "LOAD_EVENT_LIST";
export const LIST_EVENT_PAGE_NO = "LIST_EVENT_PAGE_NO";
export const EVENT_DETAIL_PAGE = "EVENT_DETAIL_PAGE";
export const POPULAR_VENUE_LIST = "POPULAR_VENUE_LIST";
export const POPULAR_EVENT_LIST = "POPULAR_EVENT_LIST";
export const POPULAR_OFFER_LIST = "POPULAR_OFFER_LIST";
export const SELECT_CITY_SORT = "SELECT_CITY_SORT";



// WEBPACK FOOTER //
// ./src/action/actionConstants.js